const imgAttributeMapping = {
  width: "w",
  height: "h",
  webp: "rw",
  png: "rp",
  jpg: "rj",
  stretch: "s",
  crop: "c"
};
const constructGoogleImageParams = (url, config) => {
  const baseUrl = url.indexOf("=") >= 0 ? url.substring(0, url.indexOf("=")) : url;
  const baseParams = url.indexOf("=") >= 0 ? url.substring(url.indexOf("=") + 1).split("-") : [];
  const mergedParams = {};
  baseParams.forEach((param) => {
    var _a;
    if (["rw", "rp", "rj"].includes(param)) {
      mergedParams["format"] = param;
    } else {
      const prefix = (_a = param.match(/^([a-z]+)(\w*)$/)) == null ? void 0 : _a[1];
      if (prefix) {
        mergedParams[prefix] = param;
      }
    }
  });
  Object.entries(config).forEach(([key, value]) => {
    if (typeof value !== "boolean" && !value)
      return;
    if (key === "format") {
      const gcsArg = imgAttributeMapping[value];
      mergedParams["format"] = gcsArg;
      return;
    }
    const gcsArgPrefix = imgAttributeMapping[key];
    if (key === "size" && value) {
      mergedParams[gcsArgPrefix] = `${gcsArgPrefix}0`;
      return;
    }
    if (gcsArgPrefix) {
      if (typeof value === "boolean") {
        mergedParams[gcsArgPrefix] = value ? gcsArgPrefix : void 0;
      } else {
        mergedParams[gcsArgPrefix] = `${gcsArgPrefix}${value}`;
      }
    }
  });
  const filterParams = Object.values(mergedParams).filter((param) => param);
  return filterParams.some((param) => param) ? `${baseUrl}=${filterParams.join("-")}` : url;
};
const getImageUrlFromGoogleUserContent = (imageUrl, config) => {
  if (imageUrl && imageUrl.includes("googleusercontent.com"))
    return constructGoogleImageParams(imageUrl, config);
  return imageUrl;
};

export { constructGoogleImageParams, getImageUrlFromGoogleUserContent };
